import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { categories } from '../../func/skills.js'
import Skills from './skills.js'

import { addTagsSearch } from '../../func/skills.js'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`

const Content = styled.div`
  padding: 25px 0 15px 30px;
  border-radius: 20px;
  transition: background-color 0.5s ease;
  margin-left: 15px;
`

const Body = styled.div`
  padding: 40px 0 40px 10px;
  width: 45vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  & > input {
    width: 80%;
  }
`

const ModifyIcon = styled.div`
  width: 70px;
  height: 70px;
  background: url('/assets/svg/modif.svg');
  position: absolute;
  top: 5px;
  right: 5px;
`

const Text = styled.input`
  font-size: 13px;
  color: rgb(108, 108, 108);
  margin: 5px 0;
  padding: 8px 0 8px 8px;
  border-radius: 5px;
  background: rgb(232, 232, 232);
  border: none;
`

const IconWrapper = styled.div`
  height: 70px;
  width: 170px;
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 9999;
  display: flex;
  justify-content: space-around;
`

const ValidIcon = styled.div`
  width: 50px;
  height: 50px;
  background: url('/assets/svg/valid.svg');
`

const CloseIcon = styled.div`
  width: 50px;
  height: 50px;
  background: url('/assets/svg/close.svg');
`
const RemoveIcon = styled.div`
  width: 50px;
  height: 50px;
  background: url('/assets/svg/remove.svg');
`

class AddUser extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      tel: '',
      firstname: '',
      lastname: '',
      job: '',
      company: '',
      adress: ''
    }
  }

  addUser = () => {
    this.props.validButton(this.state, this.props.closeAddUser)
  }

  render() {
    return (
      <Wrapper>
        <IconWrapper>
          <ValidIcon onClick={this.addUser} />
          <CloseIcon onClick={this.props.closeAddUser} />
        </IconWrapper>
        <Content>
          <Body>
            <label htmlFor="">Email: </label>
            <Text onChange={e => this.setState({ email: e.target.value })} />
            <label htmlFor="">Prenom: </label>
            <Text
              onChange={e => this.setState({ firstname: e.target.value })}
            />
            <label htmlFor="">Nom: </label>
            <Text onChange={e => this.setState({ lastname: e.target.value })} />
            <label htmlFor="">Telephone: </label>
            <Text onChange={e => this.setState({ tel: e.target.value })} />
            <label htmlFor="">Organisme: </label>
            <Text onChange={e => this.setState({ company: e.target.value })} />
            <label htmlFor="">Fonction: </label>
            <Text onChange={e => this.setState({ job: e.target.value })} />
            <label htmlFor="">Adresse: </label>
            <Text onChange={e => this.setState({ adress: e.target.value })} />
          </Body>
        </Content>
      </Wrapper>
    )
  }
}

export default AddUser



// WEBPACK FOOTER //
// ./src/components/admin/addUser.js